/** Variant-reference projections already resolve colour and sparse size upstream.
 * Absence permits legacy sets; an explicit empty projection hides them. */
if (!customElements.get('exact-set-context')) {
  customElements.define('exact-set-context', class extends HTMLElement {
    connectedCallback() {
      this.onVariantChange = (event) => {
        const scope = this.closest('product-rerender') || this.closest('.product');
        if (!scope || !scope.contains(event.target)) return;
        const id = event.detail?.variant?.id;
        if (id != null) this.selectVariant(String(id));
      };
      document.addEventListener('variant:change', this.onVariantChange);
      this.selectVariant(this.dataset.initialVariant);
    }
    disconnectedCallback() {
      document.removeEventListener('variant:change', this.onVariantChange);
    }
    selectVariant(id) {
      const content = this.querySelector('[data-exact-set-content]');
      const legacy = this.querySelector('[data-legacy-set-content]');
      const template = [...this.querySelectorAll('template[data-exact-set-variant]')]
        .find(t => t.dataset.exactSetVariant === id);
      if (!content || !legacy) return;
      content.replaceChildren(...(template ? [template.content.cloneNode(true)] : []));
      content.hidden = !template;
      legacy.hidden = !!template;
    }
  });
}
